<template>
  <v-row justify="center">
    <v-dialog v-model="open" scrollable max-width="500px">
      <v-card>
        <v-card-title>Update Resolution Status</v-card-title>
        <v-divider></v-divider>
        <div class="current-status py-4 px-6"
          v-if="employee && employee.last_chat_action_status
            && employee.last_chat_action_status !== 'Na'"
        >
          <span class="status-sub">Current status:&nbsp;</span>
          <span class="status-text">
            {{employee.last_chat_action_status.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
          </span>
        </div>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;" class="pa-0">
          <v-list v-if="employee">
            <v-list-item-group
              v-model="selected"
              active-class="primary white--text"
            >
              <template v-for="(item, index) in status">
                <v-list-item :key="item.text" :disabled="item.disabled">
                  <v-list-item-avatar>
                    <v-icon>{{item.icon}}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < status.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn text @click="open = false">Cancel</v-btn>
          <v-btn color="primary" @click="onClickUpdateStatus">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ResolutionSummary ref="ResolutionSummary" />
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import ResolutionSummary from './ResolutionSummary';

export default {
  name: 'ResolutionStatus',
  components: {
    ResolutionSummary
  },

  props: {
    type: {
      required: false,
      type: String,
      default: 'employees'
    }
  },

  data () {
    return {
      open: false,
      selected: '',
      allData: {},
      employee: null,
      status: [
        {
          text: 'Acknowledge Chat',
          icon: 'las la-check-square',
          status: 'acknowledged',
          disabled: true,
          dialog: 'Acknowledge',
          action: this.openDialog,
          permission: ['acknowledge_chat']
        }, {
          text: 'Schedule meeting',
          icon: 'lar la-calendar-alt',
          status: 'scheduled',
          disabled: true,
          dialog: 'OneOnOne',
          action: this.openDialog,
          permission: ['schedule_invite']
        }, {
          text: 'Work In Progress',
          icon: 'las la-tasks',
          status: 'inProgress',
          disabled: true,
          dialog: 'inProgress',
          action: this.updateStatus,
          permission: ['change_status']
        }, {
          text: 'Resolved',
          icon: 'las la-check',
          status: 'resolved',
          disabled: true,
          dialog: 'resolved',
          action: this.updateStatus,
          permission: ['change_status']
        }
      ]
      // actionStatus: {
      //   open: [
      //     {
      //       text: 'Acknowledge Chat',
      //       icon: 'fas fa-check-square',
      //       status: 'acknowledged',
      //       dialog: 'Acknowledge',
      //       action: this.openDialog,
      //       permission: ['acknowledge_chat']
      //     }, {
      //       text: 'Schedule meeting',
      //       icon: 'flaticon-012-meeting',
      //       status: 'scheduled',
      //       dialog: 'OneOnOne',
      //       action: this.openDialog,
      //       permission: ['schedule_invite']
      //     }, {
      //       text: 'Work In Progress',
      //       icon: 'flaticon-047-conversation',
      //       status: 'inProgress',
      //       dialog: 'inProgress',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }, {
      //       text: 'Resolved',
      //       icon: 'fas fa-check',
      //       status: 'resolved',
      //       dialog: 'resolved',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }
      //   ],
      //   acknowledged: [
      //     {
      //       text: 'Schedule meeting',
      //       icon: 'flaticon-012-meeting',
      //       status: 'scheduled',
      //       dialog: 'OneOnOne',
      //       action: this.openDialog,
      //       permission: ['schedule_invite']
      //     }, {
      //       text: 'Resolved',
      //       icon: 'fas fa-check',
      //       status: 'resolved',
      //       dialog: 'resolved',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }
      //   ],
      //   scheduled: [
      //     {
      //       text: 'Acknowledge Chat',
      //       icon: 'fas fa-check-square',
      //       status: 'acknowledged',
      //       dialog: 'Acknowledge',
      //       action: this.openDialog,
      //       permission: ['acknowledge_chat']
      //     }, {
      //       text: 'Resolved',
      //       icon: 'fas fa-check',
      //       status: 'resolved',
      //       dialog: 'resolved',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }
      //   ],
      //   inProgress: [
      //     {
      //       text: 'Acknowledge Chat',
      //       icon: 'fas fa-check-square',
      //       status: 'acknowledged',
      //       dialog: 'Acknowledge',
      //       action: this.openDialog,
      //       permission: ['acknowledge_chat']
      //     }, {
      //       text: 'Schedule meeting',
      //       icon: 'flaticon-012-meeting',
      //       status: 'scheduled',
      //       dialog: 'OneOnOne',
      //       action: this.openDialog,
      //       permission: ['schedule_invite']
      //     }, {
      //       text: 'Resolved',
      //       icon: 'fas fa-check',
      //       status: 'resolved',
      //       dialog: 'resolved',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }
      //   ],
      //   resolved: [
      //     {
      //       text: 'Work In Progress',
      //       icon: 'flaticon-047-conversation',
      //       status: 'inProgress',
      //       dialog: 'inProgress',
      //       action: this.updateStatus,
      //       permission: ['change_status']
      //     }
      //   ]
      // }
    };
  },

  watch: {
    open () {
      this.selected = '';
    },
    selected () {
      // console.log(this.companySettings.enable_resolution_summary);
      if (this.selected === 3 && this.companySettings.enable_resolution_summary !== '0') {
        this.$refs.ResolutionSummary.openResolvePopup = true;
        // console.log(this.$refs.ResolutionSummary);
      }
    },
    employee () {
      if (this.type === 'employees') {
        this.filterListEmployees();
      }
      if (this.type === 'employeesToMeet') {
        this.filterListEmployeesToMeet();
      }
    }
  },

  computed: {
    ...mapState({
      user: state => state.user,
      companySettings: state => state.csettings
    })
  },

  methods: {
    filterListEmployees () {
      this.selected = '';
      this.$lodash.each(this.status, (val) => {
        val.disabled = true;
      });
      this.$lodash.each(this.status, (val) => {
        if (this.employee && this.employee.last_chat_action_status) {
          if (this.employee.last_chat_action_status === 'open') {
            val.disabled = false;
          }
          if (this.employee.last_chat_action_status === 'acknowledged') {
            if (val.status === 'scheduled' || val.status === 'resolved' || val.status === 'inProgress') {
              val.disabled = false;
            }
          }
          if (this.employee.last_chat_action_status === 'scheduled') {
            if (val.status === 'acknowledged' || val.status === 'resolved') {
              val.disabled = false;
            }
          }
          if (this.employee.last_chat_action_status === 'inProgress') {
            if (val.status === 'acknowledged' || val.status === 'resolved' || val.status === 'scheduled') {
              val.disabled = false;
            }
          }
          if (this.employee.last_chat_action_status === 'resolved') {
            if (val.status === 'inProgress') {
              val.disabled = false;
            }
          }
        }
      });
    },
    filterListEmployeesToMeet () {
      this.selected = '';
      this.$lodash.each(this.status, (val) => {
        val.disabled = true;
      });
      this.$lodash.each(this.status, (val) => {
        if (this.employee && this.employee.action_status) {
          if (this.employee.action_status === 'open') {
            val.disabled = false;
          }
          if (this.employee.action_status === 'acknowledged') {
            if (val.status === 'scheduled' || val.status === 'resolved' || val.status === 'inProgress') {
              val.disabled = false;
            }
          }
          if (this.employee.action_status === 'scheduled') {
            if (val.status === 'acknowledged' || val.status === 'resolved') {
              val.disabled = false;
            }
          }
          if (this.employee.action_status === 'inProgress') {
            if (val.status === 'acknowledged' || val.status === 'resolved' || val.status === 'scheduled') {
              val.disabled = false;
            }
          }
          if (this.employee.action_status === 'resolved') {
            if (val.status === 'inProgress') {
              val.disabled = false;
            }
          }
        }
      });
    },
    onClickUpdateStatus () {
      const data = {};
      if ((this.companySettings.enable_resolution_summary === '0') || (this.companySettings.enable_resolution_summary !== '0' && this.selected !== 3)) {
        data.status = this.status[this.selected];
        data.emp = this.employee;
        this.$emit('onClickUpdateStatus', data);
        this.$nextTick(() => {
          this.open = false;
        });
      }
      if (this.companySettings.enable_resolution_summary !== '0' && this.selected === 3) {
        this.$refs.ResolutionSummary.openResolvePopup = true;
      }
    },
    onClickUpdateStatusWithSummary () {
      this.allData.status = this.status[this.selected];
      this.allData.emp = this.employee;
      this.$emit('onClickUpdateStatus', this.allData);
      this.$nextTick(() => {
        this.open = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.current-status {
  text-transform: capitalize;
  .status-text {
    font-size: var(--heading-size);
    color: var(--color-text);
  }
  .status-sub {
    font-size: var(--content-sub-size);
    color: var(--color-text);
  }
}
</style>
